module.exports = __webpack_public_path__ + "templates.coupon-input-1e22fdb0.html";